import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
  FormLabel,
  ListSubheader,
} from "@mui/material";
import { MyContext } from "../../Context/MyContext";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonsGroup from "./ButtonsGroup";
import { RegisterFormContext } from "../../Context/RegisterFormContext";

export default function ChooseClasses() {
  const { formData, setFormData, zero, two, setAvailableScreens } =
    useContext(RegisterFormContext);
  const [customClass, setCustomClass] = useState("");

  function handlePrev() {
    if (zero.current) {
      zero.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => {
        setAvailableScreens((prev) => ({ ...prev, screen1: false }));
        setFormData((prev) => ({
          ...prev,
          class: ""
        }))
      }, 500);
    }
  }

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      class:
        prev.program === "Others"
          ? "IGCSE / GCE / O-Level / A-Level / CAIE"
          : "",
    }));
  }, [formData.program]);

  const [selectedOption, setSelectedOption] = useState("");

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen2: true }));
    setTimeout(() => {
      if (two.current) {
        two.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  const handleClassChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "Other") {
      setCustomClass("");
      setFormData((prev) => ({
        ...prev,
        class: "",
      }));
    } else {
      setCustomClass("");
      setFormData((prev) => ({
        ...prev,
        class: selectedValue,
      }));
    }
    setSelectedOption(selectedValue);
  };

  const handleCustomClassChange = (event) => {
    const value = event.target.value;
    setCustomClass(value);
    setFormData((prev) => ({
      ...prev,
      class: value, // Save user's input to formData.class
    }));
  };

  // MYP Subject Options
  const mypSubjects = {
    "Language and Literature": ["English", "Spanish", "French"],
    "Language Acquisition": ["French", "Spanish", "Mandarin"],
    "Individuals and Societies": ["History", "Geography", "Economics"],
    Sciences: ["Biology", "Chemistry", "Physics", "Environmental Systems"],
    Mathematics: ["Mathematics", "Extended Mathematics"],
    Arts: ["Visual Arts", "Music", "Theater", "Dance"],
    "Physical and Health Education": ["Physical Education", "Health Education"],
    Design: ["Product Design", "Digital Design", "Computer Science"],
  };

  // Options for "Others"
  const otherSubjects = [
    "IGCSE",
    "GCE",
    "O-Level",
    "A-Level",
    "CAIE",
    "AQA",
    "Edexcel",
    "Other",
  ];

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: "80vh",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <Typography
          variant="h6"
          style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}
        >
          Choose class
        </Typography>

        {formData.program === "IB DP" ? (
          <RadioGroup
            row
            aria-labelledby="dp-class-selection"
            name="dp-class"
            required
            style={{ display: "flex", gap: "2rem" }}
            value={formData.class || ""}
            onChange={handleClassChange}
          >
            <FormControlLabel value="DP-1" control={<Radio />} label="DP 1" />
            <FormControlLabel value="DP-2" control={<Radio />} label="DP 2" />
          </RadioGroup>
        ) : formData.program === "Others" ? (
          <RadioGroup
            row
            aria-labelledby="dp-class-selection"
            name="dp-class"
            required
            style={{ display: "flex", gap: "2rem" }}
            value={formData.class || ""}
            onChange={handleClassChange}
          >
            <FormControlLabel
              value="IGCSE / GCE / O-Level / A-Level / CAIE"
              control={<Radio />}
              label="IGCSE / GCE / O-Level / A-Level / CAIE"
            />
          </RadioGroup>
        ) : (
          <RadioGroup
            row
            aria-labelledby="dp-class-selection"
            name="dp-class"
            required
            style={{ display: "flex", flexDirection: 'column', marginTop: '1rem' }}
            value={formData.class || ""}
            onChange={handleClassChange}
          >
            <FormControlLabel
              value="MYP - I (Year 1)"
              control={<Radio />}
              label="MYP - I (Year 1)"
            />
            <FormControlLabel
              value="MYP - II (Year 2)"
              control={<Radio />}
              label="MYP - II (Year 2)"
            />
            <FormControlLabel
              value="MYP - III (Year 3)"
              control={<Radio />}
              label="MYP - III (Year 3)"
            />
            <FormControlLabel
              value="MYP - IV (Year 4)"
              control={<Radio />}
              label="MYP - IV (Year 4)"
            />
            <FormControlLabel
              value="MYP - V (Year 5)"
              control={<Radio />}
              label="MYP - V (Year 5)"
            />
          </RadioGroup>
        )}

        <ButtonsGroup
          nextDisabled={!formData?.class}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}
